export default "__VITE_ASSET__D5EaJi8x__"